export const BRAND_NAME = 'SkyLiveCasino';
export const BRAND_DOMAIN = 'skylivecasino.com';
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
